import React, { useContext } from 'react';
import Modal from "../../components/modal/modal";
import axiosInstance from "../../AxiosInstance";
import { toast, ToastTypes } from "../../components/toasts/toast/toast";
import MyContext from "../../MyContext";
import {
    afterInvoiceActionSuccess,
    detailFromError,
    rejectFailedResponse,
} from "../bus/afterInvoiceActionSuccess";

export default function AcceptModal({show, setter, invoice}) {
    const { user } = useContext(MyContext);

    const accept = () => {
        if (invoice?.eval_status !== 4) {
            toast('Solo puede aprobar facturas pre-aprobadas.', ToastTypes.ERROR);
            return;
        }
        if (!user?.can_final_approve_invoice) {
            toast('No tiene permiso para aprobar facturas.', ToastTypes.ERROR);
            return;
        }
        axiosInstance.post('sunat/', {
            ruc_provider: invoice.purchase_order.provider.ruc,
            ruc_client: invoice.purchase_order.client.ruc,
            bill_id: invoice.id,
            conformity: 1
        }).then(rejectFailedResponse).then(() => {
            return axiosInstance.put('bill_status/' + invoice.id + '/', {
                status: 2
            }).then(rejectFailedResponse);
        }).then(() => {
            afterInvoiceActionSuccess(setter);
        }).catch((err) => {
            toast(detailFromError(err, 'No se pudo aprobar la factura.'), ToastTypes.ERROR);
        });
    }

    return (
        <Modal show={show} setter={setter} onClick={() => accept()} name={'Aprobar'} buttonName={'Aprobar'}>
            <div className={'mb-3'}>
                ¿Confirmas la aprobación del documento {invoice?.sn}? Se registrará conformidad en SUNAT y la factura
                pasará a aceptada.
            </div>
        </Modal>
    )
}
